<template>
  <div class="login">
    <!-- <img src="./assets/logo.png"> -->
    <keep-alive>
      <router-view/>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'login'
}
</script>

<style>
.login {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/login.vue